import { render } from "./app.vue?vue&type=template&id=d06eff6c"
const script = {}

import "./app.vue?vue&type=style&index=0&id=d06eff6c&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__